export default __webpack_public_path__ + "media/images/features/local_delivery/episode7/LP_02-c7c7583849097ff7c07f135bff027ce4.jpg";